export const localStorageKeys = {
	recentSearchTerms: "recentSearchTerms"
}
